"use strict";
exports.getISOWeeksInYear = getISOWeeksInYear;
var _index = require("./addWeeks.js");
var _index2 = require("./constants.js");
var _index3 = require("./startOfISOWeekYear.js");
function getISOWeeksInYear(date) {
  const thisYear = (0, _index3.startOfISOWeekYear)(date);
  const nextYear = (0, _index3.startOfISOWeekYear)(
    (0, _index.addWeeks)(thisYear, 60)
  );
  const diff = +nextYear - +thisYear;
  return Math.round(diff / _index2.millisecondsInWeek);
}
